"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _productFallback = _interopRequireDefault(require("b2b-components/theme/assets/images/product-fallback.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./ImageLink.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ImageLink = _ref => {
  let {
    className,
    imageUrl,
    onClick,
    title,
    url,
    sku
  } = _ref;
  const [hasImageError, setHasImageError] = (0, _react.useState)(false);
  const rootClassName = (0, _classnames.default)('cds-ProductBox-ImageLink', className);
  return /*#__PURE__*/_react.default.createElement("a", {
    className: rootClassName,
    href: url,
    onClick: onClick(sku)
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: title,
    className: "cds-ProductBox-Image",
    src: hasImageError ? _productFallback.default : imageUrl,
    title: title,
    onError: () => setHasImageError(true)
  }));
};
exports.ImageLink = ImageLink;
//# sourceMappingURL=ImageLink.js.map